var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer_language_box"
  }, [_c('Poptip', {
    attrs: {
      "placement": _vm.placement,
      "trigger": "click",
      "transfer": "",
      "transfer-class-name": "iw-language-poptip"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('button', {
    staticClass: "footer_language",
    attrs: {
      "type": "button",
      "aria-haspopup": "menu",
      "aria-expanded": _vm.visible
    }
  }, [_c('img', {
    staticStyle: {
      "width": "12px",
      "height": "12px"
    },
    attrs: {
      "src": require("../../assets/language.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "line"
  }), _c('div', {
    staticClass: "select"
  }, [_c('span', [_vm._v(_vm._s(_vm.chinseLanguage(_vm.language)))]), _c('img', {
    staticStyle: {
      "width": "12px",
      "height": "12px"
    },
    attrs: {
      "src": require("../../assets/select.png"),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "iw-language-menu",
    attrs: {
      "slot": "content",
      "role": "menu"
    },
    slot: "content"
  }, _vm._l(_vm.languages, function (item) {
    return _c('button', {
      key: item.lang,
      staticClass: "iw-language-menu__item",
      class: {
        'is-active': _vm.language === item.lang
      },
      attrs: {
        "type": "button",
        "role": "menuitemradio",
        "aria-checked": _vm.language === item.lang
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.switchLang(item.lang);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.displayName))]), _vm.language === item.lang ? _c('Icon', {
      attrs: {
        "type": "md-checkmark"
      }
    }) : _vm._e()], 1);
  }), 0)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };